import './styles.scss';
import { QuestionStatuses } from '@constants/status';
import { Badge } from 'reactstrap';

export const PrivacyBadge = ({ isPrivate, className = '' }: { isPrivate: boolean | undefined; className?: string }) => {
  return (
    <div className={`badge__wrapper d-inline-block ${className}`}>
      <Badge
        color={isPrivate ? 'primary' : 'success'}
        className={`question__privacy-badge px-4 py-1 ${isPrivate ? QuestionStatuses.Private : ''}`}
        pill
      >
        {isPrivate ? QuestionStatuses.Private : QuestionStatuses.Public}
      </Badge>
    </div>
  );
};
